export function useZendeskChat() {
  const hasZendeskApi = () => typeof window !== 'undefined' && typeof window.zE === 'function'

  const runZendeskAction = (channel, action) => {
    if (!hasZendeskApi()) return false

    try {
      window.zE(channel, action)
      return true
    } catch {
      return false
    }
  }

  const mount = () => {
    const chatUrl = window.APP_CONFIG.VITE_ZENDESK_CHAT_URL
    if (!chatUrl) return

    if (!document.getElementById('ze-snippet')) {
      const script = document.createElement('script')
      script.setAttribute('src', chatUrl)
      script.setAttribute('id', 'ze-snippet')
      document.head.appendChild(script)
    }
  }

  const show = () => {
    const messengerShown = runZendeskAction('messenger', 'show')
    const webWidgetShown = runZendeskAction('webWidget', 'show')
    return messengerShown || webWidgetShown
  }

  const open = () => {
    const messengerOpened = runZendeskAction('messenger', 'open')

    if (messengerOpened) {
      return true
    }

    const widgetShown = runZendeskAction('webWidget', 'show')
    const widgetOpened = runZendeskAction('webWidget', 'open')

    return widgetShown || widgetOpened
  }

  const hide = () => {
    runZendeskAction('messenger', 'close')
    runZendeskAction('messenger', 'hide')
    runZendeskAction('webWidget', 'close')
    runZendeskAction('webWidget', 'hide')
  }

  const unmount = () => {
    hide()
  }

  return { mount, unmount, show, open, hide }
}
